import client, { apiEnv } from '../client';

export const getCertificationDetails = (body, token) => client.post(token)(
  apiEnv[apiEnv.env].url(
    apiEnv.LAST_PATH.CERTIFICATION,
    apiEnv.APIS.GET_CERTIFICATION_DETAILS,
  ),
  body,
);
